module.exports = __webpack_public_path__ + "static/img/2-6.d78d2fa.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/events/summer2018/app_screen/section-2/2-6.jpg
// module id = 733
// module chunks = 1